import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-13399612"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "game-image"
}

import { PropType, ref, watch } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'GameImage',
  props: {
  image: {
    type: String as PropType<string | undefined>,
  },
  base64: {
    type: String as PropType<string | undefined>,
  },
},
  setup(__props) {

const props = __props



const reload = ref(false)

watch(
  () => props.image,
  () => {
    reload.value = true
    setTimeout(() => {
      reload.value = false
    })
  },
)

return (_ctx: any,_cache: any) => {
  const _component_base_picture = _resolveComponent("base-picture")!

  return (!reload.value && (__props.image || __props.base64))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (__props.image)
          ? (_openBlock(), _createBlock(_component_base_picture, {
              key: 0,
              name: __props.image
            }, null, 8, ["name"]))
          : _createCommentVNode("", true),
        (__props.base64)
          ? (_openBlock(), _createBlock(_component_base_picture, {
              key: 1,
              base64: __props.base64
            }, null, 8, ["base64"]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}
}

})